

export const BUSINESS_TERRITORY_STATE_VALID = "VALID";
export const BUSINESS_TERRITORY_STATE_INVALID = "INVALID";


export const MOBILE_DEVICE_STATE_INIT = "MD_I";
export const MOBILE_DEVICE_STATE_APPROVED = "MD_A";
export const MOBILE_DEVICE_STATE_CANCEL = "MD_C";

export const INVITATION_STATE_PENDING = "PENDING";
export const INVITATION_STATE_ACKNOWLEDGED = "ACKNOWLEDGED";


export const RESERVATION_HID_STATE_NEW = "NEW";
export const RESERVATION_HID_STATE_SENT = "SENT";
export const RESERVATION_HID_STATE_ENDED = "ENDED";
export const RESERVATION_HID_STATE_CANCELED = "CANCELED";


export const RESERVATION_ITEM_STATE_NEW = "NEW";
export const RESERVATION_ITEM_STATE_USED = "USED";
export const RESERVATION_ITEM_STATE_RETURNED = "RETURNED";

export const ENTITY_STATE_ACTIVE = "A";
export const ENTITY_STATE_INACTIVE = "I";

export const TENANT_GRANULARITY_DAY = "TG_DAY";
export const TENANT_GRANULARITY_HOUR = "TG_HOUR";

export const FISCALIZATION_NOT_FISCALIZED = "FISCALIZATION_NOT_FISCALIZED";
export const FISCALIZATION_SUCCESS = "FISCALIZATION_SUCCESS";
export const FISCALIZATION_ERROR = "FISCALIZATION_ERROR";
export const FISCALIZATION_AWAITING = "FISCALIZATION_AWAITING";

export const RECEIPT_STATE_INIT = "INIT";
export const RECEIPT_STATE_PAID = "PAID";
export const RECEIPT_STATE_ERROR = "ERROR";

export const PARKING_ACTIVE_STATE_INIT = "INIT";
export const PARKING_ACTIVE_STATE_PAID = "PAID";
